export const LIST_CATEGORIES = `
  query FindCategories($filter: ListCategoriesFilter!, $page: PageRequest, $orderBy: OrderByInput) {
    category {
      listCategories(filter: $filter, page: $page, orderBy: $orderBy) {
        count
        limit
        offset
        items {
          id
          name          
        }
      }
    }
  }
`;
